var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4144 8.00013L13.6879 3.72666L14.5691 2.84538C14.6991 2.71538 14.6991 2.50412 14.5691 2.37412L13.6262 1.43117C13.4962 1.30117 13.2849 1.30117 13.1549 1.43117L8.00019 6.58592L2.84544 1.43076C2.71544 1.30075 2.50418 1.30075 2.37418 1.43076L1.43082 2.3737C1.30081 2.50371 1.30081 2.71496 1.43082 2.84497L6.58598 8.00013L1.43082 13.1549C1.30081 13.2849 1.30081 13.4961 1.43082 13.6261L2.37376 14.5691C2.50377 14.6991 2.71502 14.6991 2.84503 14.5691L8.00019 9.41434L12.2737 13.6878L13.1549 14.5691C13.2849 14.6991 13.4962 14.6991 13.6262 14.5691L14.5691 13.6261C14.6991 13.4961 14.6991 13.2849 14.5691 13.1549L9.4144 8.00013Z",
    fill: "#454648"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Times.6d58d91ab356fe880332dde948bcbcb0.svg";